function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function EditIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M2.54702 21.639L9.08101 20.1988L18.8756 10.4049L17.4616 8.99089L8.16305 18.2886L5.0926 19.0934L5.89742 16.023L15.1954 6.72463L13.7813 5.31061L3.98726 15.105L2.54702 21.639Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15.1955 3.89637L20.2899 8.9907L21.6392 7.64161C23.0435 6.23731 23.0435 3.95118 21.6387 2.54688C20.2344 1.14258 17.9492 1.14258 16.5449 2.54688L15.1955 3.89637Z",
    fill: "currentColor"
  }));
}
export function EditIconSmall(props) {
  return ___EmotionJSX(EditIcon, _extends({
    size: "small"
  }, props));
}